import { format } from 'date-fns';

/**
 * The default formatter for the Year caption.
 */
export function formatYearCaption(
  year: Date,
  options?: { locale?: import('date-fns/locale').Locale }
): string {
  return format(year, 'yyyy', options);
}
